// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const LinkOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M42.392 27.144a3.002 3.002 0 0 0 4.392 4.093l.005-.005 13.434-13.435c5.13-5.129 13.257-5.129 18.386 0 5.13 5.13 5.13 13.256 0 18.385l-14.85 14.85c-5.13 5.128-13.255 5.128-18.385 0a3 3 0 1 0-4.297 4.186c.017.02.037.037.055.056 7.406 7.406 19.464 7.406 26.87 0l14.85-14.85c7.405-7.406 7.405-19.464 0-26.87-7.407-7.406-19.465-7.406-26.87 0L42.546 26.99c-.054.05-.105.102-.155.155ZM13.553 55.981c-7.405 7.406-7.405 19.464 0 26.87 7.408 7.406 19.465 7.406 26.87 0l13.437-13.436a3 3 0 1 0-4.186-4.299c-.02.018-.038.038-.057.057L36.181 78.608c-5.129 5.13-13.256 5.13-18.385 0-5.129-5.129-5.129-13.255 0-18.384l14.85-14.85c5.129-5.129 13.256-5.129 18.385 0a3 3 0 0 0 4.3-4.183l-.057-.06c-7.407-7.406-19.465-7.406-26.87 0l-14.85 14.85Z"
			fill="#fff"
		/>
	</svg>
);
export default LinkOutline;
